<template>
  <transition name="modal">
    <div class="msgBox">
      <div class="mask" @click="dismiss($event)"></div>
      <div class="message">
        <div class="title">
          Recorta la imagen al tamaño deseado
          <div class="closeBtn"><v-icon @click="cancel">close</v-icon></div>
        </div>
        <clipper-fixed
          class="my-clipper"
          ref="clipper"
          :src="image"
        ></clipper-fixed>

        <div class="footerBtn">
          <div class="btn primary" @click="save">Confirmar</div>
          <div class="btn secondary" @click="cancel">Cancelar</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: { image: String },
  data () {
    return {}
  },
  created () {
    setTimeout(function () {
      // self.$refs.clipper.setWH$.next(1)
    }, 3000)
  },
  computed: {
    zoom () {
      return this.current_zoom
    }
  },
  methods: {
    save () {
      const canvas = this.$refs.clipper.clip() // call component's clip method
      var resizedCanvas = document.createElement('canvas')
      var resizedContext = resizedCanvas.getContext('2d')
      resizedCanvas.height = '500'
      resizedCanvas.width = '500'

      resizedContext.drawImage(
        canvas,
        0,
        0,
        resizedCanvas.width,
        resizedCanvas.height
      )
      var image = canvas.toDataURL('image/webp', 0.7) // canvas->image

      this.$emit('getImage', image)
      this.$destroy()
    },
    cancel () {
      this.$emit('getImage', false)
      this.$destroy()
    }
  }
}
</script>

<style lang="scss" scoped>
.msgBox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: opacity 0.3s ease;
  -moz-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  z-index: 9999;
}
.title {
  position: relative;
  padding: 15px;
  padding-bottom: 0;
  background: #fff;
}
.closeBtn {
  position: absolute;
  top: 23px;
  right: 10px;
  transform: translateY(-50%);
  text-align: center;
  font-size: 18px;
  z-index: 999;
  cursor: pointer;
}
.footerBtn {
  display: inline-block;
  position: relative;
  margin-right: 5px;
  margin-bottom: 0;
  margin-top: 20px;
  padding: 0 0;
  line-height: 1.15;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  border: 1px solid transparent;
  border-color: #d9d9d9;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  white-space: nowrap;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  font-size: 22px;
  position: absolute;
  bottom: 0;
  left: 0;

  .btn {
    width: 50%;
    float: left;
    height: 100%;
    line-height: 50px;
    text-align: center;

    &.primary {
      background-color: $main-color !important;
      color: $bg-color;
    }
    &.secondary {
      background-color: #ccc !important;
    }
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.my-clipper {
  padding-top: 15px;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  margin-bottom: 70px;
}
.message {
  /* margin: 10px 0px; */
  padding: 0 0 !important;
  text-align: left;
  padding-left: 40px;
  font-size: 10pt;
  width: 50%;
  height: auto;
  max-height: 80%;
  margin: 5% auto;
  background-color: #fff;
  position: relative;
  position: relative;
}
</style>
